"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const shippingtruck = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-shippingtruck` : '') + (description ? ` desc-shippingtruck` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-shippingtruck"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-shippingtruck"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 5.5a.75.75 0 0 0-.75.75v7.5a.75.75 0 0 1-1.5 0v-7.5A2.25 2.25 0 0 1 2.25 4h12a2.25 2.25 0 0 1 2.121 1.5h2.379A5.25 5.25 0 0 1 24 10.75v6A2.25 2.25 0 0 1 21.75 19H21a.75.75 0 0 1 0-1.5h.75a.75.75 0 0 0 .75-.75V13h-2.25A2.25 2.25 0 0 1 18 10.75V7h-1.5v5.25a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 0-.75-.75h-12ZM19.5 7.076v3.674a.75.75 0 0 0 .75.75h2.25v-.75a3.75 3.75 0 0 0-3-3.674ZM4.5 16a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-2.121-.621A3 3 0 1 1 6.62 19.62a3 3 0 0 1-4.24-4.24ZM16.5 16a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm-2.121-.621a3 3 0 1 1 4.242 4.242 3 3 0 0 1-4.242-4.242ZM8.25 18.25A.75.75 0 0 1 9 17.5h3a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75Z"
  }));
};
var _default = exports.default = shippingtruck;